import { instance as request, redirectUrl } from './request';

/**
 * get方法
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url: string, params: any) {
  return new Promise((resolve, reject) => {
    request.get(url, { params: params })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        // reject(err.data);
        // window.location.href = redirectUrl;
      });
  });
}
/**
 * post方法
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * * @param {Object} type [类型]
 */
export function post(url: string, params: any, type?: any) {
  let _data: any = {};
  switch(type) {
    case 'formData': // formdata数据类型
      let _params = new FormData();
      for (let key in params) {
        _params.append(key, params[key]);
      }
      _data = _params;
      break;
    default:
      _data = params;
  }
  return new Promise((resolve, reject) => {
    request.post(url, _data)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        // reject(err.data);
        // window.location.href = redirectUrl;
      });
  });
}
/**
 * put方法
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url: string, params: any, type?: any) {
  let _data: any = {};
  switch(type) {
    case 'formData': // formdata数据类型
      let _params = new FormData();
      for (let key in params) {
        _params.append(key, params[key]);
      }
      _data = _params;
      break;
    default:
      _data = params;
  }
  return new Promise((resolve, reject) => {
    request.put(url, _data)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        // reject(err.data);
        // window.location.href = redirectUrl;
      });
  });
}
/**
 * dalete方法
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deletes(url: string, params: any) {
  return new Promise((resolve, reject) => {
    request.delete(url, { params: params })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        // reject(err.data);
        // window.location.href = redirectUrl;
      });
  });
}

export default {
  get,
  post,
  deletes,
  put
}
